import React, { useEffect, useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import RadioButton from "@amzn/meridian/radio-button";
import UpsertRoleRatioRule from "./UpsertRoleRatioRule";
import UpsertVolumeRatioRule from "./UpsertVolumeRatioRule";
import UpsertMinHeadcountRule from "./UpsertMinHeadcountRule";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import UpsertRateRule from "./UpsertRateRule";
import { SSD_RULE_CATEGORY, SSD_RULE_TYPE } from "../SettingsConstant";

const FIXED = "Fixed HC";
const DEMAND = "Demand role";
const ROLE_RATIO = "Role ratio rule";
const VOLUME_RATIO = "Volume ratio rule";

const UpdateRuleModal = ({ rules, rule, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRuleOption, setSelectedRuleOption] = useState(null);
  useEffect(() => {
    let ruleOption = null;
    if (
      rule.category === SSD_RULE_CATEGORY.RULE &&
      rule.type === SSD_RULE_TYPE.MIN_HEADCOUNT
    ) {
      ruleOption = FIXED;
    } else if (
      rule.category === SSD_RULE_CATEGORY.DEMAND &&
      rule.type === SSD_RULE_TYPE.RATE_BASED
    ) {
      ruleOption = DEMAND;
    } else if (
      rule.category === SSD_RULE_CATEGORY.RULE &&
      rule.type === SSD_RULE_TYPE.ROLE_RATIO
    ) {
      ruleOption = ROLE_RATIO;
    } else if (
      rule.category === SSD_RULE_CATEGORY.RULE &&
      rule.type === SSD_RULE_TYPE.VOLUME_RATIO
    ) {
      ruleOption = VOLUME_RATIO;
    }
    setSelectedRuleOption(ruleOption);
  }, [rule]);
  if (selectedRuleOption == null) {
    return (
      <Row alignmentHorizontal="end" widths="fit">
        <Icon tokens={editTokens} />
      </Row>
    );
  }
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button type="icon" onClick={() => setIsOpen(true)}>
          <div style={{ color: "#0085B3" }}>
            <Icon tokens={editTokens} />
          </div>
        </Button>
      </Row>
      <Modal
        title="Edit Requirement"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        <Row alignmentHorizontal="center">
          <RadioButton
            disabled={selectedRuleOption !== FIXED}
            checked={selectedRuleOption === FIXED}
            onChange={setSelectedRuleOption}
            value={FIXED}
            size="medium"
          >
            {FIXED}
          </RadioButton>
          <RadioButton
            disabled={selectedRuleOption !== DEMAND}
            checked={selectedRuleOption === DEMAND}
            onChange={setSelectedRuleOption}
            value={DEMAND}
            size="medium"
          >
            {DEMAND}
          </RadioButton>
          <RadioButton
            disabled={selectedRuleOption !== ROLE_RATIO}
            checked={selectedRuleOption === ROLE_RATIO}
            onChange={setSelectedRuleOption}
            value={ROLE_RATIO}
            size="medium"
          >
            {ROLE_RATIO}
          </RadioButton>
          <RadioButton
            disabled={selectedRuleOption !== VOLUME_RATIO}
            checked={selectedRuleOption === VOLUME_RATIO}
            onChange={setSelectedRuleOption}
            value={VOLUME_RATIO}
            size="medium"
          >
            {VOLUME_RATIO}
          </RadioButton>
        </Row>
        {selectedRuleOption === FIXED && (
          <UpsertMinHeadcountRule
            rules={rules}
            rule={rule}
            onSubmit={(updatedRule) => onSubmit(rule, updatedRule)}
            onCancel={() => setIsOpen(false)}
            isEditRule={true}
          />
        )}
        {selectedRuleOption === DEMAND && (
          <UpsertRateRule
            rules={rules}
            rule={rule}
            onSubmit={(updatedRule) => onSubmit(rule, updatedRule)}
            onCancel={() => setIsOpen(false)}
            isEditRule={true}
          />
        )}
        {selectedRuleOption === ROLE_RATIO && (
          <UpsertRoleRatioRule
            rules={rules}
            rule={rule}
            onSubmit={(updatedRule) => onSubmit(rule, updatedRule)}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
        {selectedRuleOption === VOLUME_RATIO && (
          <UpsertVolumeRatioRule
            rules={rules}
            rule={rule}
            onSubmit={(updatedRule) => onSubmit(rule, updatedRule)}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
      </Modal>
    </Column>
  );
};
export default UpdateRuleModal;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/UpdateRuleModal.js